import { baseURL } from '../../services/urlService';

const baselink = baseURL(window.location.href);

const memberCommentEmail = (memberName, comment, service, serviceId, uid) => {
  const link =
    service === 'Renewal' || service === 'Membership'
      ? `${baselink}/pages/member-details/${uid}`
      : `${baselink}/pages/service-request-details/${serviceId}`;

  const body = `<p>Hi ${memberName},</p>
      <p>Please take note of the comment that was made on your recent application for ${service} on the MRPCZ membership platform.</p>
      <p><strong>Comment :</strong><br>
      <em>${comment}</em></p>
      If you have issues with clicking the button, copy and post this into your browser <br>
      ${link} </p>`;

  return {
    subject: `Attention Required - MRPCZ ${service} application`,
    title: `Attention required on your ${service} application`,
    callToAction: 'View application',
    callToActionUrl: link,
    message: body
  };
};

const serviceNotificationEmail = (memberName, service, serviceId, action) => {
  const link = `${baselink}/pages/service-request-details/${serviceId}`;
  const message = `<p>Hi Admin,</p>
    <p>An application has just been made for ${service} service. Please ${action} the application for ${memberName}</p> 
    <p>If you have issues with the link copy and post this into your browser <br>
    ${link}</p>`;

  return {
    subject: `${service} ${action} required`,
    title: `MRPCZ ${service} request`,
    callToAction: 'Open application',
    callToActionUrl: link,
    message
  };
};

const memberApplicationEmail = (memberName, uid, action) => {
  const link = `${baselink}/pages/member-details/${uid}`;
  const message = `<p>Hi Admin,</p>
<p>A new membership application has just been made. Please ${action} the application for ${memberName}</p>
<p>If you have issues with the link copy and post this into your browser <br>
${link} </p>`;

  return {
    subject: `Membership application ${action} required`,
    title: 'MRPCZ Membership Application',
    callToAction: 'Open application',
    callToActionUrl: link,
    message
  };
};

const memberRenewalEmail = (memberName, uid, action) => {
  const link = `${baselink}/pages/member-details/${uid}`;
  const message = `<p>Hi Admin,</p>
<p>A renewal application has just been made. Please ${action} the application for ${memberName}</p> 
<p>If you have issues with the link copy and post this into your browser <br>
${link} </p>`;

  return {
    subject: `Renewal application ${action} required`,
    title: 'MRPCZ Renewal Application',
    callToAction: 'Open application',
    callToActionUrl: link,
    message
  };
};

const serviceApprovalEmail = (memberName, serviceType, approved) => {
  const message = `<p>Hi ${memberName},</p>
<p>Your application for ${serviceType} has been ${approved ? 'Approved' : 'Declined'}<p> 
<p>Please login to the system and check the status of your profile</p>`;

  return {
    subject: `${serviceType} ${approved ? 'Approved' : 'Declined'}`,
    title: 'MRPCZ Application Update',
    callToAction: 'View status',
    callToActionUrl: undefined,
    message
  };
};

export {
  memberCommentEmail,
  memberApplicationEmail,
  memberRenewalEmail,
  serviceNotificationEmail,
  serviceApprovalEmail
};
